import { Link } from 'gatsby';
import "./Button.css"
import { MouseEvent } from 'react';

export enum ButtonType {
    Primary,
    Secondary,
    Tertiary
}

export type ButtonProps = {
    text: string,
    icon?: string,
    external?: boolean,
    href?: string,
    onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void,
    disabled?: boolean,
    type?: ButtonType
}

const Button = (props: ButtonProps) => {
    const { text, href, onClick, icon, external = false, disabled, type = ButtonType.Primary } = props;
    let buttonClass = type === ButtonType.Secondary ? "secondary-btn" : type === ButtonType.Tertiary ? "tertiary-btn" : "default-btn";
    if (icon)
        buttonClass += " with-icon";
    return <>
        {href ?
            (external === true ? <a href={href} {...(onClick ? { onClick: onClick } : {})}
                className={buttonClass} target="_blank">
                {icon && ButtonType.Tertiary !== type && (<i className={icon}></i>)} {text}<span />
                {ButtonType.Tertiary === type && <span className={icon} />}
            </a> : <Link to={href ?? ""} className={buttonClass} {...(onClick ? { onClick: onClick } : {})}>
                {icon && ButtonType.Tertiary !== type && (<i className={icon}></i>)} {text}<span />
                {ButtonType.Tertiary === type && <span className={icon} />}
            </Link>) :
            <button type='button' disabled={disabled} className={buttonClass} {...(onClick ? { onClick: onClick } : {})}>
                {icon && ButtonType.Tertiary !== type && (<i className={icon}></i>)} {text}<span />
                {ButtonType.Tertiary === type && <span className={icon} />}
            </button>
        }
    </>
}

export default Button